/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IWhoWeAreBannerData } from './who-we-are-banner.data';
import { IWhoWeAreBannerProps } from './who-we-are-banner.props.autogenerated';

export interface IWhoWeAreBannerViewProps extends IWhoWeAreBannerProps<IWhoWeAreBannerData> {}

/**
 *
 * WhoWeAreBanner component
 * @extends {React.PureComponent<IWhoWeAreBannerProps<IWhoWeAreBannerData>>}
 */
class WhoWeAreBanner extends React.PureComponent<IWhoWeAreBannerProps<IWhoWeAreBannerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default WhoWeAreBanner;
